
// --- Vue & Template imports ---
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

// --- Models ---

// --- Services ---
import AppService from '@/services/app';
import CustomerService from '@/services/customer';

// --- Third Party ---

@Component
export default class PackageSelectionPage extends Vue {
  valid: boolean = false;
  clicked: boolean = false;
  selectedFrequencyId: number = 3;
  columns: any[] = [];

  rules = {
    required: (value: string | number) => !!value || '',
  };

  features: any[] = [
    'Personalised welcome in the 360 Hospitality Solutions newsletter, and social media platforms, distributed to some 3000 accommodation, venue, and restaurant establishments.',
    'A unique QR code linked to 360 Hospitality Solutions consumer survey.',
    'Special offer Ad in the monthly newsletter Product and service only',
    'Monthly summary based on our survey and review sites.',
    'Monthly Quality Rating compliance certificate',
    'Certificate verifying compliance to our Code of Commitment.',
    'Rotating advertisement on the 360 Hospitality Solutions website.',
    'Article in 360 Hospitality Solutions newsletter, distributed to some 3000 accommodation, venue, and restaurant establishments.',
    'Consumer Verification Report on client\'s online reviews and comparative industry standards.',
    'Training programmes available online through Learn2Succeed.',
    'Virtual exhibition space includes a monthly display of a business card, a flip file, and the products or services offered.',
    'Invite to participate in one of the 360 Hospitality Solutions hosted webinars.',
  ];

  @Watch('selectedFrequencyId', {
    immediate: true,
    deep: true,
  })
  async updatePrice() {
    this.columns = [
      {
        id: 2,
        title: 'Start-Up',
        price: this.selectedFrequencyId === 2 ? 'N/A' : 'R1,700.00',
        features: [
          'Y',
          'Y',
          '1pa',
          'N',
          'Y',
          'Y',
          'N',
          'N',
          'N',
          'N',
          'N',
          'N',
        ],
      },
      {
        id: 3,
        title: 'Silver',
        price: this.selectedFrequencyId === 2 ? 'R585.00' : 'R6,500.00',
        features: [
          'Y',
          'Y',
          '2pa',
          'N',
          'Y',
          'Y',
          '1pa',
          '1pa',
          'six monthly',
          'N',
          'N',
          'N',
        ],
      },
      {
        id: 4,
        title: 'Gold',
        price: this.selectedFrequencyId === 2 ? 'R1,170/00' : 'R13,500.00',
        features: [
          'Y',
          'Y',
          '3pa',
          'N',
          'Y',
          'Y',
          '2pa',
          '2pa',
          'Quarterly',
          'Any 2',
          'N',
          'N',
        ],
      },
      {
        id: 5,
        title: 'Diamond',
        price: this.selectedFrequencyId === 2 ? 'R1,750.00' : 'R20,500.00',
        features: [
          'Y',
          'Y',
          '4pa',
          'N',
          'Y',
          'Y',
          '3pa',
          '3pa',
          'Monthly',
          'Any 4',
          'Y',
          'Y',
        ],
      },
    ];

    // Add Marketing Package for Product and service providers only
    if (this.$store.getters['users/loggedInUser'].industryId === 3) {
      this.columns.unshift({
        id: 1,
        title: 'Marketing',
        price: this.selectedFrequencyId === 2 ? 'N/A' : 'R1,300.00',
        features: [
          'Y',
          'Y',
          '12pa',
          'Y',
          'N',
          'N',
          'N',
          'N',
          'N',
          'N',
          'N',
          'N',
        ],
      });
    }      

    // Add Feature for Product and service providers only
    if (this.$store.getters['users/loggedInUser'].industryId === 3) {
      this.columns[0].features.unshift('Y'); // Marketing
      this.columns[1].features.unshift('Y'); // Start-Up
      this.columns[2].features.unshift('Y'); // Silver
      this.columns[3].features.unshift('Y'); // Gold
      this.columns[4].features.unshift('Y'); // Diamond
    }
  }

  async beforeMount() {
    // Add Feature for Product and service providers only
    if (this.$store.getters['users/loggedInUser'].industryId === 3) {
      this.features.unshift('Listing on the 360 Hospitality Solutions Website');      
    }
  }

  // #region Functions to display list data on page load
  async updateCustomerPackage(packageTypeId: number) {
    try {
      this.clicked = true;

      const response = await CustomerService.updatePackage({
        paymentFrequencyId: this.selectedFrequencyId,
        packageTypeId: packageTypeId,
      });

      if (response && response.data) {
        if (response.data.result && response.data.result === 'false') {
          if (response.data.message === 'Reload Customer Status') {
            // when we tried to save this package selection, they already had a further along customer status, so re-fetch the auth data and figure out which page they need to be on to continue their journey
            Vue.$cookies.remove('_t'); // removing the cookie so that the auth re-fetches the updated status id's from the DB
            this.$router.push('/');
          } else {
            AppService.errorHandler(response.data.message);
          }
        } else {
          AppService.successHandler('Payment Package Selected. You will be emailed an invoice.');
          Vue.$cookies.remove('_t'); // removing the cookie so that the auth re-fetches the updated status id's from the DB
          this.$router.push('/awaiting-payment'); // go to awaiting payment
        }
      } else {
        // response is undefined or has no data field - SHOULD NEVER HAPPEN!
        throw new Error('response: ' + JSON.stringify(response));
      }
    } catch (error) {
      if (error.response) {
        AppService.errorHandler(error.response.statusText);
      } else {
        AppService.logSupportDebug('PackageSelection.vue - updateCustomerPackage - 258 - ' + error);
        AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
      }
    } finally {
      this.clicked = false;
    }
  }
  // #endregion
}
